export enum MobileOS {
  ios = 'iOS',
  android = 'Android',
}
